import React from 'react';

const DetailRow = ({ label, value }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px',
    background: '#f7fafc',
    border: '3px solid #e2e8f0',
    boxShadow: '3px 3px 0px rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease'
  }}>
    <span style={{ fontSize: '10px', color: '#718096' }}>{label}:</span>
    <span style={{ fontSize: '10px', color: '#2d3748', fontWeight: 'bold' }}>{value}</span>
  </div>
);

export default DetailRow;